<script>

export default {
	data() {
		return {
			mounted: false,
			refresh_id: 0,
			client: false,
			index: false,
			index_source: false,
			searchObject: {
				hitsPerPage: 12,
				facets: [],
				facetFilters: [],
				sortFacetValuesBy: 'count'
			},
			page_results: false,
			can_load_more: true,
			alert_id: false,
			temp_load_more: true,
			allowChanges: true,
			initial_search_complete: false,
			updatingSearch: false,
			fullSearchDebug: true
		}
	},

	methods: {
		changeSearchTerm(value) {
			this.search_params.searchTerm = value;
		},
		clearSearch() {
			this.search_params.searchTerm = '';
			this.search_params.searchGeo = null;
			this.search_params.page = 1;
			for (const [facet_name, facet_group] of Object.entries(this.search_params.global_facets)) {
				this.search_params.global_facets[facet_name] = [];
			}

			for (const [facet_name, facet_group] of Object.entries(this.search_params.global_toggle_facets)) {
				this.search_params.global_toggle_facets[facet_name] = false;
			}

			this.search_params.salaryMin = this.search_params.salaryMinRange;
			this.search_params.salaryMax = this.search_params.salaryMaxRange;
			this.emitter.emit('update:min-max');

			this.alert_id = false;

			this.updateSearch();
		},
		loadMore() {
			this.temp_load_more = true;
			this.search_params.page++;
		},
		removeFilterItem(item) {
			if (item.type == 'term') {
				this.search_params.searchTerm = '';
			}
			if (item.type == 'geo') {
				this.search_params.searchGeo = null;
			}
			if (item.type == 'facet') {
				for (const [facet_name, facet_group] of Object.entries(this.search_params.global_facets)) {
					if (facet_name == item.facet_name) {
						this.search_params.global_facets[facet_name] = _.without(this.search_params.global_facets[facet_name], item.label);
					}
				}
				for (const [facet_name, facet_group] of Object.entries(this.search_params.global_toggle_facets)) {
					if (facet_name == item.facet_name) {
						this.search_params.global_toggle_facets[facet_name] = _.without(this.search_params.global_toggle_facets[facet_name], item.label);
					}
				}
			}
			this.updateSearch();
		},
		changeFacet(data) {
			// console.log("Change Facet", data.name, data.value, this.search_params.global_facets);
			var index = this.search_params.global_facets[data.name].indexOf(data.value);

	    if (index === -1) {
	        this.search_params.global_facets[data.name].push(data.value);
	    } else {
	        this.search_params.global_facets[data.name].splice(index, 1);
	    }
		},
		processUrlSearchParams() {
			console.log("Processing Url Search Params",_.cloneDeep(this.$router.currentRoute));
			let qVal = this.$route.query.q;
			let aVal = this.$route.query.a;

			// console.log("Value of q is:",qVal);
			// console.log("Value of a is:",aVal);

			if (qVal !== undefined) {
				let query_string = decodeURIComponent(qVal);

				let search_params = new URLSearchParams(query_string);


				// Reset our salary ranges, in case they're not overwritten by values in the url.
				this.search_params.salaryMin = this.search_params.salaryMinRange;
				this.search_params.salaryMax = this.search_params.salaryMaxRange;

				// Do the same for dates.
				this.search_params.date_min = this.search_params.date_base_min;
				this.search_params.date_max = this.search_params.date_base_max;

				// Reset the toggle facets
				this.search_config.facets.filter((facet) => {
					return facet.type == 'toggle';
				}).forEach((facet) => {
					this.search_params.global_toggle_facets[facet.name] = false;
				});

				for (var pair of search_params.entries()) {
					var key = pair[0];
					var value = pair[1].replace("~", "&").replace("¶", "%"); // Don't process the commas just yet.

					//console.log("# " + key + ', ' + value);

					let facet_checkboxes = this.search_config.facets.filter((facet) => {
						return facet.type == 'checkbox' || facet.type == 'range';
					})

					// Loop over the facets
					facet_checkboxes.forEach((facet) => {
						if (key == facet.name) {
							this.search_params.global_facets[facet.name] = value.split("·");
						}
					})

					// Loop over the toggle facets
					let facet_toggles = this.search_config.facets.filter((facet) => {
						return facet.type == 'toggle';
					})
					facet_toggles.forEach((facet) => {
						if (key == facet.name) {
							this.search_params.global_toggle_facets[facet.name] = true;
						}
					})

					if (key == "query") {
						this.search_params.searchTerm = value.replace("^", ",");
					}

					if (key == "salary") {
						var value_range = value.split(",");
						this.search_params.salaryMin = parseInt(value_range[0]);
						this.search_params.salaryMax = parseInt(value_range[1]);
					}

					if (key == "location") {
						var value_range = value.split(",");
						this.search_params.searchRadius = parseInt(value_range[0]);
						this.search_params.searchGeo = { 'lat': value_range[1], 'lng': value_range[2], 'address': value_range[3].replace("^", ",") }
					}

					if (key == "page") {
						this.search_params.page = parseInt(value);
						console.log("Setting page number from url params.", value, this.search_params.page);
					}

					if (key == "order") {
						if (value !== 'undefined') {
							this.search_params.ordering = value;
							this.setAlgoliaIndex();
						}
					}

					if (key == "date") {
						var value_range = value.split(",");
						this.search_params.date_min = parseInt(value_range[0]);
						this.search_params.date_max = parseInt(value_range[1]);
					}
				}
			} else {
				this.clearSearch();
			}

			if (aVal !== undefined) {
				// Allow enough time of the alert creation panel to be created.
				this.$nextTick(() => {
					this.alert_id = aVal;
				})

			}

			//console.log("search_params after url processing", this.search_params);
		},

		performCoreSearch() {
			this.index
				.search('', this.getSearchObject(true, false))
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("core search raw results:", results);
					if (this.search_config.use_salary_fields) {
						// Publish our salary min and max back
						this.search_params.salaryMinRange = this.search_params.salaryMin = ((results.facets_stats == undefined) ? 0 : results.facets_stats['salary-low'].min);
						this.search_params.salaryMaxRange = this.search_params.salaryMax = ((results.facets_stats == undefined) ? 200000 : results.facets_stats['salary-low'].max);

						//console.log("Salary range is:", this.search_params.salaryMinRange, this.search_params.salaryMaxRange);
						this.emitter.emit('update:min-max');
					}
					this.executeSearch();
				});
		},

		executeSearch() {
			this.updatingSearch = false;
			// Update our list across the top showing which facets we have selected.
			if (this.fullSearchDebug) {
				console.log("1. ExecutingSearch with params.",this.search_params);
			}
			this.updateFiltersItemList(this.search_params);
			this.emitter.emit('update:search-params',this.search_params); // Listened to in a few places, such as the hero sections and filter bar.

			// Store the base query for the main results.
			const queries = [{
				indexName: this.search_params.ordering,
				query: this.search_params.searchTerm,
				params: this.getSearchObject(false, false)
			}];

			//console.log({queries});

			// Add any additional queries for the facet lists which might have been selected.
			for (const [facet_name, facet_group] of Object.entries(this.search_params.global_facets)) {
				if (facet_group.length > 0) {
					var addtional_query = {
						indexName: this.search_params.ordering,
						query: this.search_params.searchTerm,
						params: this.getSearchObject(false, facet_name)
					}
					queries.push(addtional_query);
				}
			}
			if (this.fullSearchDebug) {
				console.log("2. Full page queries we're about to perform:", queries);
			}
			this.client.multipleQueries(queries)
			.then((response) => {
				if (this.fullSearchDebug) {
					console.log("3. Full page query results:", _.cloneDeep(response));
				}
				if (response.results.length > 0) {

					this.page_results = response.results.shift(); // position 0 is our main results.
					if (this.fullSearchDebug) {
						console.log("4. ", this.facet_info, response);
					}

					try {
						this.facet_info.forEach((facet, fidx) => {
							var facet_results = response.results.find((r) => {
								return r.facets[facet.name] !== undefined;
							});

							if (facet_results == undefined) {
								// If the facet isn't one we were searching with, then use the results from the page.
								facet_results = this.page_results.facets[facet.name];
							} else {
								// Otherwise use the resuts from the search query.
								facet_results = facet_results.facets[facet.name];
							}

							// If the page has no results, then hide the facets, as that makes no sense.
							if (this.page_results.nbHits == 0) {
								facet_results = {};
							}

							if (facet_results !== undefined) {

								if (facet.type == 'checkbox') {
									facet.options = [];
									for (const [option_name, option_count] of Object.entries(facet_results)) {
										var option_object = {'name':option_name, 'count':option_count, 'selected':(this.search_params.global_facets[facet.name].includes(option_name))}
										facet.options.push(option_object);
									};
								}
								this.$store.commit('updateFacetInfoItem', {'index':fidx, 'item':facet});
							}
						})
					}
					catch (err) {
						console.log(err);
					}
				}

				this.can_load_more = (!this.page_results || this.page_results.hitsPerPage >= this.page_results.nbHits) ? false : true;

				//this.emitter.emit('update:facet-info',this.facet_info);
			}).then((response) => {
				this.initial_search_complete = true;
				if (!this.temp_load_more) {
					this.scrollMeTo('results');
				}
				this.temp_load_more = false;
			});
		},

		scrollMeTo(refName) {
			var element = this.$refs[refName];
			var top = element.offsetTop - 300;
			window.scrollTo(0, top);
		},

		// Clone our searchObject, so that we can apply our default forced filters without affecting our in memory version.
		getSearchObject(cleanFacets, facet_focus) {
			// Clone our defaults
			var sObj_Clone = _.cloneDeep(this.searchObject);

			if (facet_focus) {
				sObj_Clone.facets = [facet_focus];
			}
			// console.log("Looking for Facets",sObj_Clone.facets)

			// Have this set as default.
			sObj_Clone.numericFilters = [];

			if (!cleanFacets) {
				sObj_Clone = this.buildNormalFacets(sObj_Clone, facet_focus);

				sObj_Clone = this.buildToggleFacets(sObj_Clone);

				sObj_Clone = this.buildHitsPerPage(sObj_Clone);

				sObj_Clone = this.buildNumericFilters(sObj_Clone);

				sObj_Clone = this.buildGeoSearch(sObj_Clone);
			}

			// If there are any permanent facets required add those in.
			sObj_Clone.facetFilters = sObj_Clone.facetFilters.concat(this.search_config.core_facets);

			if (this.search_config.use_numeric_core_filters === true) {
				sObj_Clone.numericFilters = sObj_Clone.numericFilters.concat(this.search_config.core_numeric_filters);
			}

			// console.log("searchObject(cloned) is:",sObj_Clone);
			return sObj_Clone;
		},

		buildNormalFacets(sObj, facet_focus) {
			//global_facets
			for (const [facet_name, facet_group] of Object.entries(this.search_params.global_facets)) {
				if (facet_name !== facet_focus || facet_focus == false) {
					if (facet_group.length > 0) {

						var tmp_array = [];
						facet_group.forEach((facet_option) => {
							tmp_array.push(facet_name + ":" + facet_option);
						})
						sObj.facetFilters.push(tmp_array);
					}
				}
			}
			return sObj;
		},

		buildToggleFacets(sObj) {
			// global_toggle_facets
			for (const [facet_name, facet_group] of Object.entries(this.search_params.global_toggle_facets)) {
				if (facet_group == true) {
					sObj.facetFilters.push([facet_name + ":true"]);
				}
			};
			return sObj;
		},

		buildHitsPerPage(sObj) {
			sObj.hitsPerPage = this.search_params.hits_per_page * this.search_params.page;
			return sObj;
		},

		buildNumericFilters(sObj) {
			// If the values are at max range then actually don't apply any filter to Algolia so it includes salaries with no value set
			if (this.search_config.use_salary_fields) {

				if (this.search_params.salaryMin !== this.search_params.salaryMinRange || this.search_params.salaryMax !== this.search_params.salaryMaxRange) {
					sObj.numericFilters.push('salary-low:' + this.search_params.salaryMin + ' TO ' + this.search_params.salaryMax);
				}
			}

			if (this.search_config.use_date_fields) {
				if (this.search_params.date_min !== undefined && this.search_params.date_max !== undefined) {
					if (this.search_params.date_min !== this.search_params.date_base_min || this.search_params.date_max !== this.search_params.date_base_max) {
						var date1 = new Date(this.search_params.date_min);
						var date2 = new Date(this.search_params.date_max);
						//console.log(date1.toLocaleString('en-GB', { timeZone: 'UTC' }), date2.toLocaleString('en-GB', { timeZone: 'UTC' }));

						sObj.numericFilters.push(this.search_params.date_field + ':' + this.search_params.date_min + ' TO ' + this.search_params.date_max);
						sObj.facets.push(this.search_params.date_field);
					}
				}
			}
			return sObj;
		},

		buildGeoSearch(sObj) {
			if (this.search_config.use_geo) {
				if (this.search_params.searchGeo !== null) {
					sObj.aroundLatLng = [this.search_params.searchGeo.lat, this.search_params.searchGeo.lng].join(",");
					sObj.aroundRadius = (this.search_params.searchRadius * 1000) // km
				}
			}
			return sObj
		},


		setAlgoliaIndex() {
			let index_name = this.search_params.ordering;
			this.index = this.client.initIndex(index_name);
		},

		resetVariables() {
			// console.log("Running reset variables");
			this.search_params.searchRadius = 25;
			this.search_params.hits_per_page = this.search_config.hits_per_page;
			this.search_params.page = 1;

			this.search_params.global_facets = [];
			this.search_params.global_toggle_facets = [];

			if (this.search_config.use_search) {
				this.search_params.searchTerm = '';
			}
			if (this.search_config.use_geo) {
				this.search_params.searchGeo = null;
			}

			// Add the list of facets to our default search object.
			this.search_config.facets.forEach((facet) => {
				this.searchObject.facets.push(facet.name);

				if (facet.type == "checkbox") {
					this.search_params.global_facets[facet.name] = [];
				}
				if (facet.type == "toggle") {
					this.search_params.global_toggle_facets[facet.name] = false;
				}
			});
			this.facet_info = _.cloneDeep(this.search_config.facets);

			// console.log("Resetting facet_info",this.facet_info);

			this.search_params.ordering = this.index_source[0].index;
			this.setAlgoliaIndex();
		},

		/**
		 * This method updates the query parameters and pushes them, if the url changes our router picks it up and triggers a search.
		 */
		updateSearch() {
			this.updatingSearch = true;

			try {
				var query_array = [];
				console.log("### Update Search Query", this.search_params);

				if (this.search_params.global_facets) {
					for (const [facet_name, facet_group] of Object.entries(this.search_params.global_facets)) {
						if (facet_group.length > 0) {
							query_array.push(facet_name+"="+facet_group.join("·").replace("&","~").replace("%","¶"));
						}
					}
				}

				if (this.search_params.global_toggle_facets) {
					for (const [facet_name, facet_group] of Object.entries(this.search_params.global_toggle_facets)) {
							if (facet_group == true) {
								query_array.push(facet_name+"="+facet_group);
							}
					}
				}

				if (this.search_params.searchTerm && this.search_params.searchTerm !== "") {
					query_array.push("query=" + this.search_params.searchTerm.replace("&", "~").replace("%", "¶").replace(",", "^"));
				}

				if (this.search_config.use_salary_fields) {
					if (this.search_params.salaryMin !== this.search_params.salaryMinRange || this.search_params.salaryMax !== this.search_params.salaryMaxRange) {
						query_array.push("salary="+this.search_params.salaryMin+","+this.search_params.salaryMax);
					}
				}

				if (this.search_params.searchGeo) {
						query_array.push("location="+[this.search_params.searchRadius,this.search_params.searchGeo.lat,this.search_params.searchGeo.lng,this.search_params.searchGeo.address.replace(",","^")].join(","));
				}

				if (this.search_params.page > 1) {
						query_array.push("page="+this.search_params.page);
				}

				if (this.search_params.ordering !== "Default" && this.search_params.ordering !== "undefined" && this.search_params.ordering !== this.index_source[0].index) {
						query_array.push("order="+this.search_params.ordering);
				}

				if (this.search_params.date_min && this.search_params.date_max) {
					if (this.search_params.date_min !== this.search_params.date_base_min || this.search_params.date_max !== this.search_params.date_base_max) {
						query_array.push("date="+this.search_params.date_min+','+this.search_params.date_max);
					}
				}
				var query = query_array.join("&");
				let query_object = { q: encodeURIComponent(query)};
				if (this.alert_id) {
					query_object.a = this.alert_id;
				}

				// If we don't allow parameter changes, and the query is now different then redirect.
				// console.log("query_object.q",decodeURIComponent(query_object.q),"this.search_config.initial_search",decodeURIComponent(decodeURIComponent(this.search_config.initial_search)));
				if (decodeURIComponent(query_object.q) !== decodeURIComponent(decodeURIComponent(this.search_config.initial_search)) && !this.allowChanges) {
					// Do a hard redirect, so that we load sidebars etc through the controller.
					window.top.location = '/search/' + this.search_config.role + ((query_object.q == '') ? '' : '?q='+query_object.q);
					// this.$router.push({name: this.search_config.role, query: query_object})
				} else {
					let old_query = (this.$route.query.q == undefined) ? '' : this.$route.query.q;
					if (old_query !== query_object.q) {
						if (query_object.q == '') {
							this.$router.push({ name: this.$router.currentRoute.name });
						} else {
							this.$router.push({ name: this.$router.currentRoute.name, query: query_object });
						}
					}
				}
			}
			catch(err) {
				console.log("Update Search Error",err);
			}
		},

		setFacet(facet_name,value) {
			console.log("Setting Facet `"+facet_name+"` to ",value)
			// console.log(this.search_params.global_facets);
			this.search_params.global_facets[facet_name] = [value];
			this.debounceUpdateSearch();
		},

		updateFiltersItemList(search_params) {
			console.log({search_params});
			this.filter_items = [];
			if (search_params.searchTerm && search_params.searchTerm !== '') {
				this.filter_items.push({'type':'term', 'label':search_params.searchTerm});
			}

			if (search_params.global_facets) {
				for (const [facet_name, facet_group] of Object.entries(search_params.global_facets)) {
					if (facet_group.length > 0) {
						facet_group.forEach((item_name) => {
							this.filter_items.push({'type':'facet', 'facet_name':facet_name, 'label':item_name});
						})
					}
				}
			}

			if (search_params.global_toggle_facets) {
				for (const [facet_name, facet_group] of Object.entries(search_params.global_toggle_facets)) {
					if (facet_group == true) {
						let found = this.search_config.facets.find((facet) => {
							return facet.name == facet_name;
						});

						if (found) {
							this.filter_items.push({'type':'facet', 'facet_name':facet_name, 'label':found.label});
						}
					}
				}
			}

			if (search_params.searchGeo) {
				this.filter_items.push({'type':'geo', 'facet_name':'geo', 'label':search_params.searchGeo.address});
			}

			this.emitter.emit('update:filter_items', this.filter_items);


			// If we're on a collection and we have no results redirect to the main page.
			if (this.filter_items.length == 0) {
				if (this.redirect_on_clear) {
					if (this.type == 'job') {
						this.$router.push({ name: 'jobs' });
					} else {
						this.$router.push({ name: 'organisations' });
					}
				}
			}
		}
	},
	computed: {
		// 2 Way binding bits
		search_config: {
			get() {
				return this.$store.getters.getSearchConfig;
			},
			set(value) {
				this.$store.commit('updateSearchConfig', value);
			}
		},
		facet_info: {
			get() {
				return this.$store.getters.getFacetInfo;
			},
			set(value) {
				this.$store.commit('updateFacetInfo', value);
			}
		},
		search_params: {
			get() {
				return this.$store.getters.getSearchParams;
			},
			set(value) {
				this.$store.commit('updateSearchParams', value);
			}
		},
		filter_items: {
			get() {
				return this.$store.getters.getFilterItems;
			},
			set(value) {
				this.$store.commit('updateFilterItems', value);
			}
		}
	},
	watch: {
		search_params: {
			deep: true,
			handler() {
				if (this.mounted) {
					//console.log('The search_params have changed, but we\'re debouncing!', this.search_params);
					this.debounceUpdateSearch();
				}
			}
		},
		alert_id: {
			deep:false,
			handler() {
				this.emitter.emit('update:editing-alert-id',this.alert_id);
			}
		}
	}

}

</script>
